import React from 'react'
import { useHistory } from 'react-router'
import HeaderNew from 'presentation/shared/components/HeaderNew'
import { ReactComponent as CalendarCheckIcon } from 'presentation/assets/icons/calendar-check.svg'
import { ReactComponent as MessageIcon } from 'presentation/assets/icons/message-icon.svg'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import CardNew from 'presentation/shared/components/CardNew'
import { ContainerNew } from 'presentation/shared/components/ContainerNew'
import * as S from './styles'

export default function AmbulatoryCategoriesLayout() {
  const history = useHistory()

  return (
    <>
      <HeaderNew
        actualPageOnClick={() => history.push('/home')}
        actualPageTitle="Autorização ambulatorial"
      />
      <ContainerNew
        title="Autorização ambulatorial"
        titleColor="neutral800"
        titleSize="medium"
        titleWeight="bold"
        subtitle="Navegue pelas categorias"
        // gap="24px"
        style={{ paddingBottom: 0 }}
      >
        <S.Wrapper>
          <CardNew
            className="card"
            background="neutral25"
            shadow="satin"
            onClick={() =>
              history.push('/pedidos-autorizacao-ambulatorial/dashboard')
            }
          >
            <CalendarCheckIcon />
            <SupportTextNew
              weight="bold"
              color="neutral800"
              style={{ margin: '8px 0 4px' }}
            >
              Pedidos ambulatoriais
            </SupportTextNew>

            <SupportTextNew size="xsmall" style={{ lineHeight: '1.4' }}>
              Veja as datas e status dos procedimentos e/ou medicações dos seus
              pacientes
            </SupportTextNew>
          </CardNew>

          <CardNew
            className="card"
            background="neutral25"
            shadow="satin"
            onClick={() =>
              history.push('/pedidos-autorizacao-ambulatorial/solicitacao')
            }
          >
            <MessageIcon />
            <SupportTextNew
              weight="bold"
              color="neutral800"
              style={{ margin: '8px 0 4px' }}
            >
              Solicitar pedido ambulatorial
            </SupportTextNew>

            <SupportTextNew size="xsmall" style={{ lineHeight: '1.4' }}>
              Solicite a criação do pedido ambulatorial do seu paciente
            </SupportTextNew>
          </CardNew>
        </S.Wrapper>
      </ContainerNew>
    </>
  )
}
